import {unwrapAPIError} from 'utils'
import {getFlightdeckBaseUrl, requestHandler} from '../HTTP'
import {HttpMethods, EndPoints} from '../HTTP/HTTP.types'
import {
  SSPMApplicationsAPIParams,
  SSPMApplicationsAPIResponseData,
  SSPMAppDetailsAPIParams,
  SSPMAppDetailsResponseData,
} from 'interfaces'
import Logger from 'services/Logger'

const flightDeckBaseUrl = getFlightdeckBaseUrl()
const SSPMNeuralBaseUrl = `${flightDeckBaseUrl}${EndPoints.SSPMNeural}`

const getSSPMApplications = async (data: {
  provider?: string
  params?: SSPMApplicationsAPIParams
}): Promise<SSPMApplicationsAPIResponseData> => {
  try {
    const {data: responseData} =
      await requestHandler<SSPMApplicationsAPIResponseData>({
        method: HttpMethods.GET,
        url: `${SSPMNeuralBaseUrl}/${data.provider}${EndPoints.SSPMApps}`,
        options: {
          params: {
            ...data.params,
          },
        },
      })
    return responseData
  } catch (error) {
    Logger.LogError(error as Error)
    throw unwrapAPIError(error)
  }
}

const getSSPMAppDetails = async (data: {
  provider?: string
  msObjectId: string
  params?: SSPMAppDetailsAPIParams
}): Promise<SSPMAppDetailsResponseData> => {
  try {
    const {data: responseData} =
      await requestHandler<SSPMAppDetailsResponseData>({
        method: HttpMethods.GET,
        url: `${SSPMNeuralBaseUrl}/${
          data.provider
        }${EndPoints.SSPMAppDetails.replace('{msObjectId}', data.msObjectId)}`,
        options: {
          params: {
            ...data.params,
          },
        },
      })
    return responseData
  } catch (error) {
    Logger.LogError(error as Error)
    throw unwrapAPIError(error)
  }
}

export const SSPMService = {
  getSSPMApplications,
  getSSPMAppDetails,
}
